var IS_DENO = require('../internals/engine-is-deno');
var IS_NODE = require('../internals/engine-is-node');

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';



// WEBPACK FOOTER //
// /Users/stephen.tait/Local Sites/storyiq/app/public/web/wp-content/themes/jaywing/node_modules/core-js/internals/engine-is-browser.js